<ng-container *ngIf="!!content?.length">
  <ng-container *ngFor="let child of content; let i = index">
    <ng-template [carsFragmentHost]="[child]" [readOnly]="readOnly"></ng-template>
    <span *ngIf="showSeparator(i)">{{ getSeparator(i) }}</span>
  </ng-container>
</ng-container>
